if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-card__product',
          activeClass: 'is-active',
        };

        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this.boundInit = this.init.bind(this);
        this.boundToggle = this.toggle.bind(this);
        this.boundOutsideClick = this.handleOutsideClick.bind(this);
        this.boundResize = this.init.bind(this);

        this.init();

        this.addEventListener('mouseover', this.boundInit);
        this.addEventListener('click', this.boundToggle);
        document.addEventListener('click', this.boundOutsideClick);
        window.addEventListener('resize', this.boundResize);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this.boundInit);
        this.removeEventListener('click', this.boundToggle);
        document.removeEventListener('click', this.boundOutsideClick);
        window.removeEventListener('resize', this.boundResize);
      }

      init() {
        if (!this.cardContainer || !this.cardProduct) return;

        this.cardContainerOffsetX = this.cardContainer.getBoundingClientRect().left;
        this.cardContainerOffsetY = this.cardContainer.getBoundingClientRect().top;

        this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
        this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

        this.cardProductWidth = this.cardProduct.offsetWidth;
        this.cardProductHeight = this.cardProduct.offsetHeight;
        this.cardContainerWidth = this.cardContainer.clientWidth;

        this.cardProduct.style.left = '';
        this.cardProduct.style.right = '';
        this.cardProduct.style.top = '';
        this.cardProduct.style.bottom = '';
        this.cardProduct.style.transform = '';

        if (this.offsetX > this.cardProductWidth) {
          this.cardProduct.style.left = 'auto';

          if (this.cardContainerWidth - this.offsetX < 15) {
            this.cardProduct.style.right = 'calc(-100% + 2rem)';
          } else {
            this.cardProduct.style.right = '-100%';
          }
        } else {
          this.cardProduct.style.right = 'auto';

          if (this.cardContainerWidth - this.offsetX > this.cardProductWidth) {
            if (this.offsetX < 15) {
              this.cardProduct.style.left = 'calc(-100% + 2rem)';
            } else {
              this.cardProduct.style.left = '-100%';
            }
          } else {
            this.cardProduct.style.left = this.cardContainerWidth - this.cardProductWidth - this.offsetX + 'px';
          }
        }

        if (this.offsetY > this.cardProductHeight) {
          this.cardProduct.style.top = 'auto';
          this.cardProduct.style.bottom = '100%';
        } else {
          this.cardProduct.style.bottom = 'auto';
          this.cardProduct.style.top = '100%';
        }

        this.keepInsideMobileViewport();
      }

      toggle(event) {
        if (!this.cardProduct) return;

        const clickedProductLink = event.target.closest('a');

        if (clickedProductLink && this.cardProduct.contains(clickedProductLink)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.init();

        const isActive = this.classList.contains(this.selectors.activeClass);

        document.querySelectorAll('lookbook-icon.is-active').forEach((icon) => {
          if (icon !== this) {
            icon.classList.remove(this.selectors.activeClass);
          }
        });

        this.classList.toggle(this.selectors.activeClass, !isActive);

        if (!isActive) {
          window.requestAnimationFrame(() => {
            this.keepInsideMobileViewport();
          });
        }
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.classList.remove(this.selectors.activeClass);
        }
      }

      keepInsideMobileViewport() {
        if (!this.cardProduct || window.innerWidth > 767) return;

        const viewportPadding = 12;
        const viewportWidth = window.innerWidth;
        const maxTooltipWidth = viewportWidth - viewportPadding * 2;

        this.cardProduct.style.maxWidth = `${maxTooltipWidth}px`;

        const productRect = this.cardProduct.getBoundingClientRect();

        let shiftX = 0;

        if (productRect.left < viewportPadding) {
          shiftX = viewportPadding - productRect.left;
        }

        if (productRect.right > viewportWidth - viewportPadding) {
          shiftX = (viewportWidth - viewportPadding) - productRect.right;
        }

        if (shiftX !== 0) {
          this.cardProduct.style.transform = `translateX(${shiftX}px)`;
        }
      }
    }
  );
}